import { queryOptions } from "@tanstack/react-query"
import { request } from "@utils/request"
import type { Role } from "@utils/roles"

export type User = {
  puzzelUserId: string
  firstName: string
  lastName: string
  solutionCustomerId: string
  solutionUid: string
  vaSolutionUid: string | null
  userUid: string
  roles: Role[]
  expiry: Date
  solutions: {
    uid: string
    name: string
    userUid: string
  }[]
}

export const meQuery = queryOptions({
  queryKey: ["me"] as const,
  queryFn: (): Promise<User> => {
    return request.get("auth/user").json<User>()
  },
  // oxlint-disable-next-line no-magic-numbers
  staleTime: 5 * 60 * 1000,
})
